//Version:0.0.1
//Author:Harsha
//Last Edit:Harsha
//Modified Date:26-08-2025
const InstrumentActionTypes = {
	/********************************** START - GET ALL INSTRUMENT ACTION DETAILS ****************************/
	GET_INSTRUMENT_LIST_START: 'get_instrument_list_start',
	GET_INSTRUMENT_LIST_SUCCESS: 'get_instrument_list_success',
	GET_INSTRUMENT_LIST_FAILURE: 'get_instrument_list_failure',
	GET_INSTRUMENT_LIST_RESPONSE_RESET: 'get_instrument_list_response_reset',
	GET_INSTRUMENT_LIST_RESPONSE_CHANGED: 'get_instrument_list_response_changed',
	/************************************ END - GET ALL INSTRUMENT ACTION DETAILS *****************************/

	/********************************** START - CREATE INSTRUMENT ACTION DETAILS ******************************/
	CREATE_INSTRUMENT_START: 'create_instrument_start',
	CREATE_INSTRUMENT_SUCCESS: 'create_instrument_success',
	CREATE_INSTRUMENT_FAILURE: 'create_instrument_failure',
	CREATE_INSTRUMENT_RESPONSE_RESET: 'create_instrument_response_reset',
	CREATE_INSTRUMENT_RESPONSE_CHANGED: 'create_instrument_response_changed',
	/********************************** END - CREATE INSTRUMENT ACTION DETAILS *********************************/

	/******************************* START - GET PARTICULAR INSTRUMENT ACTION DETAILS **************************/
	GET_PARTICULAR_INSTRUMENT_START: 'get_particular_instrument_start',
	GET_PARTICULAR_INSTRUMENT_SUCCESS: 'get_particular_instrument_success',
	GET_PARTICULAR_INSTRUMENT_FAILURE: 'get_particular_instrument_failure',
	GET_PARTICULAR_INSTRUMENT_RESPONSE_RESET: 'get_particular_instrument_response_reset',
	GET_PARTICULAR_INSTRUMENT_RESPONSE_CHANGED: 'get_particular_instrument_response_changed',
	/********************************** END - GET PARTICULAR INSTRUMENT ACTION DETAILS **************************/

	/******************************* START - DELETE INSTRUMENT ACTION DETAILS ***********************************/
	DELETE_INSTRUMENT_START: 'delete_instrument_start',
	DELETE_INSTRUMENT_SUCCESS: 'delete_instrument_success',
	DELETE_INSTRUMENT_FAILURE: 'delete_instrument_failure',
	DELETE_INSTRUMENT_RESPONSE_RESET: 'delete_instrument_response_reset',
	DELETE_INSTRUMENT_RESPONSE_CHANGED: 'delete_instrument_response_changed',
	/********************************* END - DELETE INSTRUMENT ACTION DETAILS ***********************************/

	/******************************* START - UPDATE INSTRUMENT ACTION DETAILS ***********************************/
	UPDATE_INSTRUMENT_START: 'update_instrument_start',
	UPDATE_INSTRUMENT_SUCCESS: 'update_instrument_success',
	UPDATE_INSTRUMENT_FAILURE: 'update_instrument_failure',
	UPDATE_INSTRUMENT_RESPONSE_RESET: 'update_instrument_response_reset',
	UPDATE_INSTRUMENT_RESPONSE_CHANGED: 'update_instrument_response_changed',
}; /******************************* END - UPDATE INSTRUMENT ACTION DETAILS ************************************/

export default InstrumentActionTypes;
